import { Component } from "react";
import { Box } from "@chakra-ui/react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { getAvatarById } from "src/modules/avatar/duck/selectors";

import Metadata from "./Metadata";
import HistoryTimeline from "./HistoryTimeline";

const metadataHeight = `${38 + 24}px`;

class MonitoringDetail extends Component {
  render() {
    const {
      avatar,
      monitoring,
      openEventView,
      toggleFreemiumFlow,
      fetchEventThumbnail,
      toggleShare
    } = this.props;
    return (
      <Box px="24px" height="100%">
        <Box mb="24px">
          <Metadata
            deviceName={monitoring.data.deviceName}
            duration={monitoring.data.duration}
            avatar={avatar}
            toggleShare={toggleShare}
            monitoring={monitoring}
          />
        </Box>
        <Box pb="16px" height={`calc(100% - ${metadataHeight})`}>
          <HistoryTimeline
            toggleFreemiumFlow={toggleFreemiumFlow}
            avatar={avatar}
            monitoring={monitoring.data}
            openEventView={openEventView}
            fetchEventThumbnail={fetchEventThumbnail}
          />
        </Box>
      </Box>
    );
  }
}

function mapStateToProps(state, props) {
  const { avatarId } = props.monitoring?.data || {};

  return {
    avatar: avatarId ? getAvatarById(state, avatarId.value) : null
  };
}

const enhance = compose(connect(mapStateToProps));

export default enhance(MonitoringDetail);
